import * as React from 'react';

import useLocalStore from 'hooks/useLocalStore';

import { useBasicFormStore } from '../BasicFormStore';

import EditFormStore from './EditFormStore';
import { EditFormStoreMediator } from './EditFormStoreMediator';

type EditFormStoreContextValue = {
  editFormStore: EditFormStore;
  editFormStoreMediator: EditFormStoreMediator;
};

const EditFormStoreContext =
  React.createContext<EditFormStoreContextValue | null>(null);

export const EditFormStoreContextProvider = ({
  children,
}: React.PropsWithChildren) => {
  const basicStore = useBasicFormStore();

  const editFormStoreMediator = useLocalStore(
    () => new EditFormStoreMediator()
  );

  const editFormStore = useLocalStore(
    () => new EditFormStore({ basicStore, mediator: editFormStoreMediator })
  );

  return (
    <EditFormStoreContext.Provider
      value={{
        editFormStore,
        editFormStoreMediator,
      }}
    >
      {children}
    </EditFormStoreContext.Provider>
  );
};

export const useEditFormStore = () => {
  const context = React.useContext(EditFormStoreContext);

  if (!context) {
    throw new Error('EditFormStoreContext is not provided');
  }

  return context;
};
